import React, { useEffect } from "react";
import Blog from "./components/blog";
import Demo from "./components/demo";
import Features from "./components/feature";
import DemoNav from "./components/DemoNav";
import DemoHome from "./components/DemoHome";
import Demotemplate from "./components/Demotemplate";
import Rating from "./components/Rating";
import { blogs, features } from "../Data/Demodata/Demo";
import Demofooter from "./components/Demofooter";

const DemoApp = () => {
  useEffect(() => {
    document.body.classList.remove("inner-page");
    document.body.classList.add("landing-page");
  }, []);

  return (
    <div>
      {/*home section*/}
      <DemoNav />
      {/*home section end*/}

      {/*Home Section*/}
      <DemoHome />
      {/*Home Section End*/}

      {/*home demo section*/}
      <Demo />
      {/*home demo section end*/}

      {/*other page section*/}
      <Blog blogs={blogs} />
      {/*other page section end*/}

      {/*main feature section*/}
      <Features features={features} />
      {/*main feature section end*/}

      {/*template section*/}
      <Demotemplate />
      {/*template section end*/}

      {/*Rate template section*/}
      <Rating />
      {/*Rate template section end*/}

      {/*Footer Section start*/}
      <Demofooter />
      {/*Footer Section End*/}
    </div>
  );
};

export default DemoApp;
